import request from './service.js'
// const baseUrl = 'https://cmp-booklib-api.work.zving.com/';
const baseUrl = 'https://serve.cmpreading.com/cmp-service/';
//登录
export const login = (token) => {
  return request
      .get(`${baseUrl}front/permit/login?token=${token}`)
      .then((res) => res.data)
      .catch((err) => err);
};


